import { atom } from "jotai";

export const sidebarMenuPinnedState = atom<boolean>(false);